import { useState, type ReactNode } from "react";
import { Pause, Play } from "lucide-react";
import { Marquee } from "../components/motion/marquee";
import skylineAsset from "../assets/blogs-hero-skyline.png";
import "./BlogsHero.css";

const communityWorkers = [
  { image: "electrical.jpg", field: "Electrical work", description: "Electrician working on an electrical installation" },
  { image: "construction.jpg", field: "Construction", description: "Construction worker working with timber" },
  { image: "home-service.jpg", field: "Cleaning services", description: "Cleaner caring for a home" },
  { image: "professional-services.jpg", field: "Office & digital work", description: "Office professional working on a laptop" },
  { image: "plumbing.jpg", field: "Plumbing", description: "Plumber repairing pipework" },
];

function CommunityCarousel() {
  const [paused, setPaused] = useState(false);
  return <section className={`bp-community-strip blogs-hero-banner${paused ? " blogs-hero-paused" : ""}`} aria-label="Stories from the working community">
    <Marquee speed={48} gap="0px" pauseOnHover fade={false} className="blogs-hero-marquee">
      {communityWorkers.map(worker => <figure key={worker.field} className="bp-film-panel">
        <img src={`/hero/${worker.image}`} alt={worker.description} draggable={false} />
        <figcaption>{worker.field}</figcaption>
      </figure>)}
    </Marquee>
    <div className="bp-film-shade" />
    <div className="bp-film-copy"><span className="bp-eyebrow">YOUR NEXT CHAPTER STARTS HERE</span>
      <h2>Every detail you care about is a signature you leave behind.</h2>
      <p>Keep learning. Keep growing. The right opportunity could be your next step.</p>
    </div>
    <button className="blogs-hero-pause" aria-label={paused ? "Resume carousel" : "Pause carousel"} aria-pressed={paused} onClick={() => setPaused(value => !value)}>
      {paused ? <Play size={18} aria-hidden="true" /> : <Pause size={18} aria-hidden="true" />}
    </button>
  </section>;
}


export default function BlogsHero({ search, topics }: { search: ReactNode; topics: ReactNode }) {
  return <header className="blogs-hero">
    <div className="blogs-hero-stage">
      <div className="blogs-hero-copy">
        <span className="blogs-hero-kicker">KONTRATAPH BLOG & INSIGHTS</span>
        <h1>Discover. Learn. Grow.</h1>
        <p>Explore career tips, business insights, industry trends, and inspiring stories that help you move forward.</p>
        {search}
      </div>
      <div className="blogs-hero-city" aria-hidden="true">
        <div className="blogs-hero-skyline blogs-hero-distant"><img src={skylineAsset} alt="" /></div>
        <div className="blogs-hero-skyline"><img src={skylineAsset} alt="" /></div>
      </div>
    </div>
    <CommunityCarousel />
    <div className="blogs-hero-topics">{topics}</div>
  </header>;
}
